import socialLinks from "fragments/socialLinks"
import { gql } from "graphql-tag"

export default gql`
  ${socialLinks}

  fragment Vendor on Vendor {
    bio
    countryId
    createdAt
    id
    isPublished
    logoImageId
    name
    publishedAt
    slug
    socialLinks {
      ...SocialLinks
    }
    splashImageId
    updatedAt
  }
`
